import roundToTwoDecimals from './roundToTwoDecimals';

/**
 * Formats the given float to a percentage.
 * @param {Number} floatValue
 */
const formatPercent = floatValue => `${roundToTwoDecimals(floatValue * 100)}%`;

export default formatPercent;
